<template>
    <div :class="{
            'ldc-select-mobile': true,
        }" v-if="$detect == 'mobile'">
        <div :class="{
                'ldc-placeholder-select-mobile d-flex justify-content-between px-2': true,
                'placeholder-ios': !$isAndroid,
                'placeholder-android': $isAndroid
            }" @click="active = true">
            <div class="ldc-placeholder" v-if="showPlaceholder">{{placeholder}}</div>
            <div :style="`${showPlaceholder ? 'width: 50%; overflow: hidden;' : 'width: 100%; overflow: hidden;'}`"
                class="value-select-mobile">
                <span>{{model}}</span> <i class="icon ion-md-arrow-dropdown fs-20px ml-1"></i>
            </div>
        </div>
        <div :class="{
                'ldc-option-mobile position-fixed': true,
            }" v-show="active" :style="`height: ${maxHeight}px`">
            <div :class="{
                    'ldc-content-option-mobile bg-white pt-2': true,
                    'radius-ios': !$isAndroid,
                    'rounded': $isAndroid,
                }" v-click-outside="outside">
                <div class="title-select-mobile text-center border-bottom fw-600">{{title}}</div>
                <div class="select-mobile-main">
                    <slot/>
                </div>
                <div class="button-select border-top">
                    <div v-if="!$isAndroid" class="d-flex">
                        <div class="w-50 text-center" @click="active = false">{{buttonCancel}}</div>
                        <div class="w-50 text-center border-left fw-600" @click="active = false">{{buttonSelect}}</div>
                    </div>
                    <div v-else class="d-flex justify-content-end text-uppercase">
                        <div class="px-3" @click="active = false">{{buttonCancel}}</div>
                        <div class="px-3" @click="active = false">{{buttonSelect}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: 'placeholder'
        },
        value: {
            default: '',
        },
        title: {
            type: String,
            default: 'Tiêu đề',
        },
        buttonCancel: {
            type: String,
            default: 'Cancel'
        },
        buttonSelect: {
            type: String,
            default: 'OK'
        },
        clickoutside: {
            type: Boolean,
            default: true,
        },
        selectClose: {
            type: Boolean,
            default: true,
        },
        showPlaceholder: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            data: '',
            model: '',
            active: false,
            options: [],
            change: null,
            maxHeight: 0,
        }
    },
    updated() {
        this.activeOption();
    },
    watch: {
        value: {
            handler(val){
                this.data = val;
            },
            deep: true,
        },
        data: {
            handler(val){
                this.$emit('input', val);
                this.activeOption();
            },
            deep: true,
        },
        active(val){
            if(val){
                setTimeout(() => {
                    this.setMaxHeight();
                }, 1)
                this.$overflowHidenBody();
            }else{
                this.$removeOverflowHidenBody();
            }
        },
        options: {
            handler(val){
                this.activeOption();
            },
            deep: true,
        },
    },
    created() {
        if(this.$detect != 'mobile'){
            console.error('Component ldc-select-mobile chỉ hoạt động trên mobile');
        }
        let listeners = this.$listeners
        if(typeof(listeners.change) == 'function'){
            this.change = listeners.change;
        }
        this.data = this.value;
    },
    mounted(){

    },
    methods: {
        setMaxHeight(){
            this.maxHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            let height = window.visualViewport ? window.visualViewport.height * 0.6 : window.innerHeight * 0.6;
            let el = this.$el;
            let content = el.querySelector('.ldc-content-option-mobile');
            content.style.maxHeight = height + 'px';
            let main = el.querySelector('.select-mobile-main');
            let title = el.querySelector('.title-select-mobile');
            if(title){
                title = title.offsetHeight;
            }else{
                title = 0;
            }
            let button = el.querySelector('.button-select');
            if(button){
                button = button.offsetHeight;
            }else{
                button = 0;
            }
            main.style.maxHeight = (height - title - button - 8) + 'px';
        },
        activeOption(){
            let check = true;
            this.$children.map(item => {
                if(item.$options && item.$options._componentTag === 'ldc-option-mobile' &&
                    item.$props.label != undefined && item.$props.value != undefined){
                    if(this.data === item.$props.value){
                        item.$data.model = this.data;
                        this.model = item.$props.label;
                        item.$data.labelModel = this.model;
                        check = false;
                    }else{
                        item.$data.model = '';
                        item.$data.labelModel = '';
                    }
                }
            });
            if(check){
                this.model = '';
            }
        },
        outside(e){
            if(this.clickoutside && this.$el.querySelector('.ldc-option-mobile') === e.target){
                this.active = false;
            }
        }
    },
}
</script>